export default "__VITE_ASSET__Y5E3HaTA__"